import * as React from 'react';
import { TableOutlined, ThunderboltOutlined } from '@ant-design/icons';

interface IGameList {
    id: string;
    name: string;
    gameId: number;
    icon: JSX.Element;
}

const gamesList: IGameList[] = [
    {
        id: 'vm',
        gameId: 1,
        name: 'Visual Memory',
        icon: <TableOutlined size={30} />,
    },
    {
        id: 'rt',
        gameId: 2,
        name: 'Reaction Time',
        icon: <ThunderboltOutlined size={30} />,
    },
    {
        id: 'sm',
        gameId: 3,
        name: 'Sequence Memory',
        icon: <ThunderboltOutlined size={30} />,
    },
    {
        id: 'at',
        gameId: 4,
        name: 'Aim Trainer',
        icon: <ThunderboltOutlined size={30} />,
    },
    {
        id: 'ct',
        gameId: 5,
        name: 'Chimp Test',
        icon: <ThunderboltOutlined size={30} />,
    }
];

export default gamesList;